import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BACKEND_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tmo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // token invalid -> clear
      localStorage.removeItem("tmo_token");
      localStorage.removeItem("tmo_user");
    }
    // Daily-cap / premium-only signal from /api/tutor/* — dispatch global event so
    // the UpgradeModal component can render. Skip for /pricing & /subscribe calls.
    if (err?.response?.status === 402) {
      const detail = err.response.data?.detail || "";
      const url = err.response.config?.url || "";
      if (typeof detail === "string" && !url.includes("/tutor/subscribe")) {
        const m = detail.match(/^(DAILY_CAP_REACHED|PREMIUM_ONLY):([a-z_]+)/);
        if (m) {
          window.dispatchEvent(new CustomEvent("tutor:dailyCap", {
            detail: { feature: m[2], premiumOnly: m[1] === "PREMIUM_ONLY" },
          }));
        }
      }
    }
    return Promise.reject(err);
  },
);
